import type { FormikProps } from 'formik';
import type { NorfolkSouthernFormValues } from './norfolkSouthernFormUtils';

export interface SelectOption<Value extends string = string> {
  value: Value;
  label: string;
}

export type NorfolkSouthernFormik = FormikProps<NorfolkSouthernFormValues>;

/** A field's error once the user has touched it; untouched fields stay quiet. */
export function visibleFieldError(
  formik: NorfolkSouthernFormik,
  name: keyof NorfolkSouthernFormValues,
): string | undefined {
  return formik.touched[name] && formik.errors[name]
    ? String(formik.errors[name])
    : undefined;
}
